import React, { useState, useEffect } from "react";
import { Form, Col, Row, Button, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { Typeahead } from "react-bootstrap-typeahead";

import "react-datepicker/dist/react-datepicker.css";
import "../styles/PhysicalMeasurements.css";
import { toast } from "react-toastify";
import axiosInstance from "../axiosInstance";

export default function PhysicalMeasurements() {
  const [startDate, setStartDate] = useState(new Date());
  const [reference_number, setReferenceNumber] = useState([]);
  const [lob_cdl, setLobCDL] = useState(0);
  const [lob_anaethetised, setLobAnaethetised] = useState(0);
  const [head_between_eyes, setHeadBetweenEyes] = useState(0);
  const [head_base_of_skull, setHeadBaseOfSkull] = useState(0);
  const [lot_dorsal, setLotDorsal] = useState(0);
  const [lot_ventral, setLotVentral] = useState(0);
  const [nose_with_loss_of_scales, setNoseWithLossOfScales] = useState(0);
  const [nose_without_loss_of_scales, setNoseWithoutLossOfScales] = useState(0);
  const [girth, setGirth] = useState(0);
  const [left_leg, setLeftLeg] = useState(0);
  const [left_foot_width, setLeftFootWidth] = useState(0);
  const [left_foot_length, setLeftFootLength] = useState(0);
  const [right_leg, setRightLeg] = useState(0);
  const [right_foot_width, setRightFootWidth] = useState(0);
  const [right_foot_length, setRightFootLength] = useState(0);
  const [dorsal_scale_pattern, setDorsalScalePattern] = useState("");
  const [ventral_scale_pattern, setVentralScalePattern] = useState("");
  const [observations, setObservations] = useState("");
  const [options, setOptions] = useState([]);
  const [showSave, setShowSave] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleCloseSave = () => setShowSave(false);
  const handleCloseSuccess = () => setShowSuccess(false);
  const handleSave = () => {
    submit();
    setShowSave(false);
  };
  function handleShowSave(e) {
    e.preventDefault();
    setShowSave(true);
  }

  async function getReferences() {
    const result = await axiosInstance.get("/api/all-reference-numbers");
    const numbers = result.data;
    const refs = [];
    numbers.forEach((element) => {
      refs.push(element.reference_number);
    });
    setOptions(refs);
  }

  useEffect(() => {
    getReferences();
  }, []);

  async function submit() {
    const ref = reference_number[0];
    var result = await axiosInstance.post("/api/add-physical-measurements", {
      date: startDate,
      reference_number: ref,
      lob_cdl,
      lob_anaethetised,
      head_between_eyes,
      head_base_of_skull,
      lot_dorsal,
      lot_ventral,
      nose_with_loss_of_scales,
      nose_without_loss_of_scales,
      girth,
      left_leg,
      left_foot_width,
      left_foot_length,
      right_leg,
      right_foot_width,
      right_foot_length,
      dorsal_scale_pattern,
      ventral_scale_pattern,
      observations,
    });

    if (result.data.code !== "ER_PARSE_ERROR") {
      toast.success(result.data, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      });
      setStartDate(new Date());
      setReferenceNumber([]);
      setLobCDL(0);
      setLobAnaethetised(0);
      setHeadBetweenEyes(0);
      setHeadBaseOfSkull(0);
      setLotDorsal(0);
      setLotVentral(0);
      setNoseWithLossOfScales(0);
      setNoseWithoutLossOfScales(0);
      setGirth(0);
      setLeftLeg(0);
      setLeftFootWidth(0);
      setLeftFootLength(0);
      setRightLeg(0);
      setRightFootWidth(0);
      setRightFootLength(0);
      setDorsalScalePattern("");
      setVentralScalePattern("");
      setObservations("");
    } else {
      toast.error(result.data.sqlMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      });
    }
  }

  return (
    <div className="measurements">
      <div className="formGroup">
        <h2 className="heading">Physical Measurements</h2>
        <Form.Group as={Col} controlId="formGroupDate">
          <DatePicker
            className="datepicker"
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            showTimeSelect
            timeIntervals={1}
            dateFormat="dd/MM/yyyy HH:mm"
          />
        </Form.Group>
        <Form>
          <Row>
            <Col xs={3}>
              <Form.Group as={Col} controlId="formGroupReference">
                <Form.Label>Reference Number</Form.Label>
                <Typeahead
                  id="reference-number"
                  labelKey="name"
                  onChange={setReferenceNumber}
                  options={options}
                  placeholder="Choose a reference number..."
                  selected={reference_number}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group as={Col} controlId="formGroupCDL">
                <Form.Label>
                  Length of Body (CDL), When Curled in a Ball (Tip of Nose to
                  Tip of Tail)
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Length of Body (CDL), When Curled in a Ball (Tip of Nose to
                  Tip of Tail)"
                  value={lob_cdl}
                  onChange={(e) => {
                    const regex = new RegExp(
                      "^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$"
                    );
                    if (regex.test(e.target.value)) {
                      const s = e.target.value.replace(
                        /^(?:0+(?=[1-9])|0+(?=0$))/gm,
                        ""
                      );
                      setLobCDL(s);
                    } else if (e.target.value === "") {
                      setLobCDL(0);
                    }
                  }}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupAnaethetised">
                <Form.Label>
                  Length of Body Anaethetised (Tip of Nose to Tip of Tail)
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Length of Body Anaethetised (Tip of Nose to Tip of Tail)"
                  value={lob_anaethetised}
                  onChange={(e) => {
                    const regex = new RegExp(
                      "^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$"
                    );
                    if (regex.test(e.target.value)) {
                      const s = e.target.value.replace(
                        /^(?:0+(?=[1-9])|0+(?=0$))/gm,
                        ""
                      );
                      setLobAnaethetised(s);
                    } else if (e.target.value === "") {
                      setLobAnaethetised(0);
                    }
                  }}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupHeadEyes">
                <Form.Label>Head Measurement (Between Eyes)</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Head Measurement (Between Eyes)"
                  value={head_between_eyes}
                  onChange={(e) => {
                    const regex = new RegExp(
                      "^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$"
                    );
                    if (regex.test(e.target.value)) {
                      const s = e.target.value.replace(
                        /^(?:0+(?=[1-9])|0+(?=0$))/gm,
                        ""
                      );
                      setHeadBetweenEyes(s);
                    } else if (e.target.value === "") {
                      setHeadBetweenEyes(0);
                    }
                  }}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Form.Group as={Col} controlId="formGroupDorsal">
                <Form.Label>
                  Length of Tail from Anus to Tip - Dorsal
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Length of Tail from Anus to Tip - Dorsal"
                  value={lot_dorsal}
                  onChange={(e) => {
                    const regex = new RegExp(
                      "^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$"
                    );
                    if (regex.test(e.target.value)) {
                      const s = e.target.value.replace(
                        /^(?:0+(?=[1-9])|0+(?=0$))/gm,
                        ""
                      );
                      setLotDorsal(s);
                    } else if (e.target.value === "") {
                      setLotDorsal(0);
                    }
                  }}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupVentral">
                <Form.Label>
                  Length of Tail from Anus to Tip - Ventral
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Length of Tail from Anus to Tip - Ventral"
                  value={lot_ventral}
                  onChange={(e) => {
                    const regex = new RegExp(
                      "^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$"
                    );
                    if (regex.test(e.target.value)) {
                      const s = e.target.value.replace(
                        /^(?:0+(?=[1-9])|0+(?=0$))/gm,
                        ""
                      );
                      setLotVentral(s);
                    } else if (e.target.value === "") {
                      setLotVentral(0);
                    }
                  }}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupHeadSkull">
                <Form.Label>
                  Head Measurement (From Base of Skull to Tip of Nose)
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Head Measurement (From Base of Skull to Tip of Nose)"
                  value={head_base_of_skull}
                  onChange={(e) => {
                    const regex = new RegExp(
                      "^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$"
                    );
                    if (regex.test(e.target.value)) {
                      const s = e.target.value.replace(
                        /^(?:0+(?=[1-9])|0+(?=0$))/gm,
                        ""
                      );
                      setHeadBaseOfSkull(s);
                    } else if (e.target.value === "") {
                      setHeadBaseOfSkull(0);
                    }
                  }}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Form.Group as={Col} controlId="formGroupWOScaleLoss">
                <Form.Label>
                  Flesh Portion of Nose (Without Loss of Scales)
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Flesh Portion of Nose (Without Loss of Scales)"
                  value={nose_without_loss_of_scales}
                  onChange={(e) => {
                    const regex = new RegExp(
                      "^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$"
                    );
                    if (regex.test(e.target.value)) {
                      const s = e.target.value.replace(
                        /^(?:0+(?=[1-9])|0+(?=0$))/gm,
                        ""
                      );
                      setNoseWithoutLossOfScales(s);
                    } else if (e.target.value === "") {
                      setNoseWithoutLossOfScales(0);
                    }
                  }}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupWithScaleLoss">
                <Form.Label>
                  Flesh Portion of Nose (WITH Loss of Scales)
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Flesh Portion of Nose (WITH Loss of Scales)"
                  value={nose_with_loss_of_scales}
                  onChange={(e) => {
                    const regex = new RegExp(
                      "^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$"
                    );
                    if (regex.test(e.target.value)) {
                      const s = e.target.value.replace(
                        /^(?:0+(?=[1-9])|0+(?=0$))/gm,
                        ""
                      );
                      setNoseWithLossOfScales(s);
                    } else if (e.target.value === "") {
                      setNoseWithLossOfScales(0);
                    }
                  }}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupRibGirth">
                <Form.Label>Girth at Last Set of Ribs</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Girth at Last Set of Ribs"
                  value={girth}
                  onChange={(e) => {
                    const regex = new RegExp(
                      "^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$"
                    );
                    if (regex.test(e.target.value)) {
                      const s = e.target.value.replace(
                        /^(?:0+(?=[1-9])|0+(?=0$))/gm,
                        ""
                      );
                      setGirth(s);
                    } else if (e.target.value === "") {
                      setGirth(0);
                    }
                  }}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Form.Group as={Col} controlId="formGroupLLegLength">
                <Form.Label>Left Leg - Length</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Left Leg - Length"
                  value={left_leg}
                  onChange={(e) => {
                    const regex = new RegExp(
                      "^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$"
                    );
                    if (regex.test(e.target.value)) {
                      const s = e.target.value.replace(
                        /^(?:0+(?=[1-9])|0+(?=0$))/gm,
                        ""
                      );
                      setLeftLeg(s);
                    } else if (e.target.value === "") {
                      setLeftLeg(0);
                    }
                  }}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupLFootWidth">
                <Form.Label>Left Foot - Width</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Left Foot - Width"
                  value={left_foot_width}
                  onChange={(e) => {
                    const regex = new RegExp(
                      "^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$"
                    );
                    if (regex.test(e.target.value)) {
                      const s = e.target.value.replace(
                        /^(?:0+(?=[1-9])|0+(?=0$))/gm,
                        ""
                      );
                      setLeftFootWidth(s);
                    } else if (e.target.value === "") {
                      setLeftFootWidth(0);
                    }
                  }}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupLFootLength">
                <Form.Label>Left Foot - Length</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Left Foot - Length"
                  value={left_foot_length}
                  onChange={(e) => {
                    const regex = new RegExp(
                      "^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$"
                    );
                    if (regex.test(e.target.value)) {
                      const s = e.target.value.replace(
                        /^(?:0+(?=[1-9])|0+(?=0$))/gm,
                        ""
                      );
                      setLeftFootLength(s);
                    } else if (e.target.value === "") {
                      setLeftFootLength(0);
                    }
                  }}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Form.Group as={Col} controlId="formGroupRLegLength">
                <Form.Label>Right Leg - Length</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Right Leg - Length"
                  value={right_leg}
                  onChange={(e) => {
                    const regex = new RegExp(
                      "^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$"
                    );
                    if (regex.test(e.target.value)) {
                      const s = e.target.value.replace(
                        /^(?:0+(?=[1-9])|0+(?=0$))/gm,
                        ""
                      );
                      setRightLeg(s);
                    } else if (e.target.value === "") {
                      setRightLeg(0);
                    }
                  }}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupRFootWidth">
                <Form.Label>Right Foot - Width</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Right Foot - Width"
                  value={right_foot_width}
                  onChange={(e) => {
                    const regex = new RegExp(
                      "^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$"
                    );
                    if (regex.test(e.target.value)) {
                      const s = e.target.value.replace(
                        /^(?:0+(?=[1-9])|0+(?=0$))/gm,
                        ""
                      );
                      setRightFootWidth(s);
                    } else if (e.target.value === "") {
                      setRightFootWidth(0);
                    }
                  }}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupRFootLength">
                <Form.Label>Right Foot - Length</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Right Foot - Length"
                  value={right_foot_length}
                  onChange={(e) => {
                    const regex = new RegExp(
                      "^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$"
                    );
                    if (regex.test(e.target.value)) {
                      const s = e.target.value.replace(
                        /^(?:0+(?=[1-9])|0+(?=0$))/gm,
                        ""
                      );
                      setRightFootLength(s);
                    } else if (e.target.value === "") {
                      setRightFootLength(0);
                    }
                  }}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Form.Group as={Col} controlId="formGroupDorsalLineScalePattern">
                <Form.Label>
                  Scale Pattern - Dorsal Line Head to Tail
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Scale Pattern - Dorsal Line Head to Tail"
                  value={dorsal_scale_pattern}
                  onChange={(e) => setDorsalScalePattern(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupVentralLineScalePattern">
                <Form.Label>
                  Scale Pattern - Ventral Line Head to Tail
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Scale Pattern - Ventral Line Head to Tail"
                  value={ventral_scale_pattern}
                  onChange={(e) => setVentralScalePattern(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Form.Group as={Col} controlId="formGroupDetails">
                <Form.Label>Other Observations</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Other Observations"
                  value={observations}
                  onChange={(e) => setObservations(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Button
                className="submit-button"
                type="submit"
                onClick={(e) => {
                  handleShowSave(e);
                }}
              >
                Submit
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
      <div>
        <Modal show={showSave} onHide={handleCloseSave}>
          <Modal.Header closeButton>
            <Modal.Title>Save</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p>Are you sure you want to save this device.</p>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseSave}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSave}>
              Save changes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <div>
        <Modal show={showSuccess} onHide={handleCloseSuccess}>
          <Modal.Header closeButton>
            <Modal.Title>Success</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Successfuly Submited.</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseSuccess}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
}
